import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Row } from 'write-excel-file';

import type { WidgetExportOptions } from 'src/components/dashboard/DashboardPage/components/WidgetFrame/useWidgetExport';
import type { AggregateList } from 'src/components/followUp/common/types';

type UseExportOptionsProps = {
  data: AggregateList | null;
} & Pick<WidgetExportOptions, 'widgetName' | 'queryFilters'>;

export const useExportOptions = ({
  data,
  widgetName,
  queryFilters,
}: UseExportOptionsProps): WidgetExportOptions => {
  const { t } = useTranslation('followUp');

  return useMemo(() => {
    const headers = [
      t('statistics.rootCausesWidget.exportHeader'),
      t('statistics.rootCausesWidget.amount'),
    ];
    const rows: Row[] = (data?.results || []).map((result) => [
      {
        value: result.label,
      },
      {
        value: result.value,
      },
    ]);

    // Add total at the bottom:
    if (data?.totalObjects)
      rows.push([
        {
          value: t('statistics.total'),
        },
        {
          value: data.totalObjects,
        },
      ]);

    return {
      widgetName: widgetName,
      headers,
      rows,
      queryFilters,
    };
  }, [data, t]);
};
